module.exports = __webpack_public_path__ + "images/grey-compare-arrows-bf4c2bb6.svg";